import { styled } from "@mui/material/styles";
import { Box, Card } from "@mui/material";

export const CardContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "80px 16px 16px",
    maxWidth: "900px",
    margin: "auto",
});

export const PairCard = styled(Card)({
    display: "flex",
    alignItems: "center",
    padding: "16px",
    borderRadius: "10px",
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.06)",
});
